import React from "react";
import { Tooltip } from "@mui/material";

interface Props {
  value?: string | null;
  limit?: number;
  onClick?: () => void;
  isPointer?: boolean;
  className?: string;
}

const TruncatedText: React.FC<Props> = ({
  value,
  limit = 20,
  onClick,
  isPointer = false,
  className,
}) => {
  if (!value) return <>-</>;

  const isLong = value.length > limit;
  const truncated = isLong
    ? value.substring(0, limit) + "..."
    : value;

  const content = (
    <span
      onClick={onClick}
      className={className}
      style={{
        display: "inline-block",
        cursor: (onClick || isPointer) ? "pointer" : "default",
      }}
    >
      {truncated}
    </span>
  );

  return isLong ? (
    <Tooltip title={value} arrow>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default TruncatedText;